import { deleteApi, getApi, postApi, putApi, putUploadImagesApi } from "../helpers/auth_helpers";

const base = process.env.REACT_APP_SERVERURL || "";

const LOOM_PHOTO_MAX_BYTES = 8 * 1024 * 1024;

const photoMime = (file: File): string => {
  const mime = file?.type || "";
  if (mime === "image/jpeg" || mime === "image/png" || mime === "image/heic") {
    return mime;
  }
  const name = String(file?.name || "").toLowerCase();
  if (name.endsWith(".png")) {
    return "image/png";
  }
  if (name.endsWith(".heic")) {
    return "image/heic";
  }
  return "image/jpeg";
};

export const listLooms = (params: {
  offset?: number;
  limit?: number;
  giId?: string;
  loomCode?: string;
  active?: boolean;
}) => {
  const q = new URLSearchParams();
  q.set("offset", String(params.offset ?? 0));
  q.set("limit", String(params.limit ?? 10));
  if (params.giId) q.set("giId", params.giId);
  if (params.loomCode) q.set("loomCode", params.loomCode);
  if (params.active === true || params.active === false) {
    q.set("active", String(params.active));
  }
  return getApi(`${base}/geo/looms?${q.toString()}`);
};

export const getLoom = (id: string) => getApi(`${base}/geo/looms/${id}`);

export const getLoomSummary = () => getApi(`${base}/geo/looms/summary`);

export const listLoomPins = (giId?: string) => {
  const q = new URLSearchParams();
  if (giId) q.set("giId", giId);
  return getApi(`${base}/geo/looms/pins?${q.toString()}`);
};

export const createLoom = (body: Record<string, unknown>) =>
  postApi(`${base}/geo/looms`, body);

export const updateLoom = (id: string, body: Record<string, unknown>) =>
  putApi(`${base}/geo/looms/${id}`, body);

export const bindLoomQr = (id: string, qrCode: string) =>
  postApi(`${base}/geo/looms/${id}/bind-qr`, { qrCode });

export const setLoomActive = (id: string, active: boolean) =>
  putApi(`${base}/geo/looms/${id}/status`, { active });

export const deleteLoom = (id: string) => deleteApi(`${base}/geo/looms/${id}`, {});

export const getPublicLoom = async (loomCode: string) => {
  const res = await fetch(`${base}/geo/looms/public/${encodeURIComponent(loomCode)}`);
  return res.json();
};

export const checkGiContains = (giId: string, lat: number, lng: number) =>
  postApi(`${base}/geo/gi/contains`, { giId, lat, lng });

export const uploadLoomPhoto = async (file: File): Promise<string> => {
  const mime = photoMime(file);
  if (!file?.type?.startsWith("image/") && !/\.(jpe?g|png|heic)$/i.test(file?.name || "")) {
    throw new Error("Upload a photo (JPEG, PNG, or HEIC)");
  }
  if (file.size > LOOM_PHOTO_MAX_BYTES) {
    throw new Error("Photo must be 8 MB or smaller");
  }
  const presigned: any = await postApi(`${base}/upload/geoLoomPhotoPresignedURL`, {
    fileType: mime,
  });
  const presignedUrl: string = presigned?.data;
  if (!presigned?.success || !presignedUrl) {
    throw new Error(presigned?.message || "Could not get upload URL");
  }
  const putRes: any = await putUploadImagesApi(presignedUrl, file, {
    "Content-Type": mime,
  });
  if (putRes && putRes.ok === false) {
    throw new Error("Could not upload the photo");
  }
  return String(presignedUrl).split("?")[0];
};
